var exports = {
  "qS": "SettingsStatusBadge.module__badge___d3l2Qz",
  "Hl": "SettingsStatusBadge.module__new___d3l2Qz",
  "ny": "SettingsStatusBadge.module__experimental___d3l2Qz",
  "jp": "SettingsStatusBadge.module__badges___d3l2Qz",
};

module.exports = exports;
